import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfileAreasOfSpecialisation.scss'
import React from 'react';

const AdviserProfileAreasOfSpecialisation = ({
  areas,
  children
}) => {
  const sortedAreas = [...(areas || [])].sort((a, b) =>
    a.orderId - b.orderId)
  return <div>
    <h4 className={styles['title']}>Services offered {children}</h4>
    <ul className={styles['list']}>
      {sortedAreas.length <= 0 && <li>Not specified</li>}
      {sortedAreas.map((specialisation, index) => {
        return <li className={specialisation.className ? specialisation.className : ''} key={index}>
          {specialisation.name}
        </li>
      }
      )}
    </ul>
  </div>
}

AdviserProfileAreasOfSpecialisation.propTypes = {
  areas: PropTypes.array.isRequired,
  children: PropTypes.object
}

export default (AdviserProfileAreasOfSpecialisation)
